export const iconFontAwesomeSecurityPersonMilitaryRifle = (
	<i className="fa-solid fa-person-military-rifle"></i>
);
